export default __webpack_public_path__ + "static/media/tshock_konfety.a44c969e.jpg";